import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import { contactsApi } from './contactsApi';

import type { IContact } from '../contacts.types';

// Define the type for state
interface ContactsState {
  accountList: IContact[] | null;
}

const initialState: ContactsState = { accountList: null };

const contactsSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    setContactList: (state, action: PayloadAction<IContact[]>) => {
      state.accountList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(contactsApi.endpoints.createContact.matchFulfilled, (state, action) => {
        state.accountList = state.accountList
          ? [...state.accountList, action.payload]
          : [action.payload];
      })
      .addMatcher(contactsApi.endpoints.updateContact.matchFulfilled, (state, action) => {
        state.accountList = state.accountList
          ? state.accountList.map((account) =>
              account.id === action.payload.id ? action.payload : account
            )
          : [];
      })
      .addMatcher(contactsApi.endpoints.filterContact.matchFulfilled, (state, action) => {
        state.accountList = action.payload.list;
      });
    // .addMatcher(contactsApi.endpoints.deleteAccount.matchFulfilled, (state, action) => {
    //   state.accountList =
    //     state.accountList?.filter((account) => account.id !== action.payload.id) || [];
    // });
  },
});

export const { setContactList } = contactsSlice.actions;
export default contactsSlice.reducer;
